module.exports = __webpack_public_path__ + "img/chevron-down_lightgray.ed1bdcaa.svg";